import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import './Admin.css'; // Admin sayfaları için genel bir CSS dosyası olduğunu varsayalım

const API_URL = process.env.REACT_APP_API_URL;

const CustomerDetailPage = () => {
    const { customerId } = useParams();
    const { token } = useAuth();
    const { t, i18n } = useTranslation();
    
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchCustomerDetails = async () => {
            if (!token) return;
            setLoading(true);
            try {
                const response = await fetch(`${API_URL}/api/admin/customers/${customerId}/details`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) {
                    const data = await response.json();
                    throw new Error(t(data.messageKey) || 'Müşteri bilgileri alınamadı.');
                }
                const data = await response.json();
                setCustomer(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchCustomerDetails();
    }, [customerId, token, t]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString(i18n.language, {
            year: 'numeric', month: 'long', day: 'numeric'
        });
    };

    if (loading) return <div className="page-container"><h2>{t('loading')}...</h2></div>;
    if (error) return <div className="page-container"><p className="error-message">{error}</p></div>;
    if (!customer) return null;

    return (
        <div className="page-container admin-dashboard">
            <div className="page-header modern">
                <h1>{t('customer_details')}</h1>
            </div>

            <div className="customer-details-grid">
                <div className="admin-card">
                    <h3>{customer.first_name} {customer.last_name}</h3>
                    <p><strong>{t('email')}:</strong> {customer.email}</p>
                    <p><strong>{t('phone')}:</strong> {customer.phone_country_code} {customer.phone_number}</p>
                    <p><strong>{t('registration_date')}:</strong> {formatDate(customer.created_at)}</p>
                </div>
                <div className="admin-card">
                    <h3>{t('statistics')}</h3>
                    <p><strong>{t('total_orders')}:</strong> {customer.totalOrders}</p>
                    <p><strong>{t('total_spent')}:</strong> {customer.totalSpent.toLocaleString(i18n.language, { style: 'currency', currency: 'TRY' })}</p>
                </div>
            </div>

            <div className="admin-card" style={{marginTop: '30px'}}>
                <h3>{t('order_history')}</h3>
                <div className="admin-table-container">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>{t('order_id')}</th>
                                <th>{t('status')}</th>
                                <th>{t('date_customer')}</th>
                                <th>{t('amount')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customer.jobs.length > 0 ? (
                                customer.jobs.map(job => (
                                    <tr key={job.id}>
                                        <td>
                                            <Link to={`/management/jobs/${job.id}`}>#{job.id}</Link>
                                        </td>
                                        <td>
                                            <span className={`status-badge status-${job.status}`}>{t(job.status)}</span>
                                        </td>
                                        <td>{formatDate(job.created_at)}</td>
                                        <td>{parseFloat(job.price).toLocaleString(i18n.language, { style: 'currency', currency: 'TRY' })}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="table-row-message">{t('no_orders_found')}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CustomerDetailPage;